export var LifecycleOperation;
(function (LifecycleOperation) {
    LifecycleOperation["Delete"] = "delete";
    LifecycleOperation["Restore"] = "restore";
    LifecycleOperation["Freeze"] = "freeze";
    LifecycleOperation["Unfreeze"] = "unfreeze";
})(LifecycleOperation || (LifecycleOperation = {}));
//# sourceMappingURL=lifeCycleOperation.js.map